import {createSelector} from '@reduxjs/toolkit'
import {RootState} from 'app/rootReducer'
import {searchHeaderEveryone} from 'definitions/constant'
import {AnalyticsDetailState, POLICY_TYPE, RESOURCE_TYPE} from 'interfaces'

export const selectAnalyticsDetailState = (
  state: RootState,
): AnalyticsDetailState => state.analyticsDetail

export const selectPolicyTypeFilter = createSelector(
  selectAnalyticsDetailState,
  ad => ad.policyType,
)

export const isPolicyFilterSelected = createSelector(
  selectAnalyticsDetailState,
  ad => ad.policyType?.some(type => type === POLICY_TYPE.Policy),
)

export const isMalwareFilterSelected = createSelector(
  selectAnalyticsDetailState,
  ad => ad.policyType?.some(type => type === POLICY_TYPE.Malware),
)

export const isCACFilterSelected = createSelector(
  selectAnalyticsDetailState,
  ad => ad.policyType?.some(type => type === POLICY_TYPE.CAC),
)

export const selectResourceTypeFilter = createSelector(
  selectAnalyticsDetailState,
  ad => ad.resourceType,
)

export const isLocationFilterSelected = createSelector(
  selectAnalyticsDetailState,
  ad => ad.resourceType.some(item => item === RESOURCE_TYPE.Location),
)

export const isUserFilterSelected = createSelector(
  selectAnalyticsDetailState,
  ad => ad.resourceType.some(item => item === RESOURCE_TYPE.Users),
)

export const selectCategoryFromFilterDetails = createSelector(
  selectAnalyticsDetailState,
  ad => ad.filterDetails?.category || '',
)

export const selectSortAscendingState = createSelector(
  selectAnalyticsDetailState,
  ad => ad.sortAscending,
)

export const selectSearchHeaderText = createSelector(
  selectAnalyticsDetailState,
  ad => {
    const {userEmail, groupEmail, city, country} = ad?.filterDetails || {}
    let headerText = ''
    if (userEmail) {
      headerText = userEmail
    } else if (groupEmail) {
      headerText = groupEmail
    } else if (city && country) {
      headerText = `${city}, ${country}`
    } else {
      headerText = searchHeaderEveryone
    }

    return headerText
  },
)
